
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import FeedbackRequestForm from './FeedbackRequestForm';
import CollectiveFeedbackForm from './collective/CollectiveFeedbackForm';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/context/AuthContext';
import { useRoleMapping } from '@/hooks/useRoleMapping';
import { Mail, Users } from 'lucide-react';

const UnifiedRequestForm = () => {
  const [activeTab, setActiveTab] = useState<string>("individual");
  const { profile } = useAuth();
  const { isCorporate } = useRoleMapping();
  
  return (
    <div className="max-w-4xl mx-auto py-8">
      <Card>
        <CardContent className="pt-6">
          <Tabs defaultValue={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid grid-cols-2 w-full mb-8">
              <TabsTrigger value="individual" className="flex items-center gap-1">
                <Mail className="h-4 w-4" />
                <span>Demande individuelle</span>
              </TabsTrigger>
              {isCorporate && (
                <TabsTrigger value="collective" className="flex items-center gap-1">
                  <Users className="h-4 w-4" />
                  <span>Demande collective</span>
                </TabsTrigger>
              )}
            </TabsList>
            
            <TabsContent value="individual" className="space-y-4">
              <FeedbackRequestForm />
            </TabsContent>
            
            {isCorporate && (
              <TabsContent value="collective" className="space-y-4">
                <CollectiveFeedbackForm />
              </TabsContent>
            )}
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default UnifiedRequestForm;
